<template>
  <div>
    <!-- Packaging attribute -->
    <div
      v-if="service"
      class="product-attributes packaging"
    >
      <Tooltip
        v-for="attributeValue in service.attribute_values"
        :text="getAttributeTooltipText(language, product, attributeValue)"
        :class="[
          `attribute-${attributeValue.id}`,
          {
            sold: soldProductWithAttribute(product, attributeValue.id),
          },
        ]"
      >
        <div
          :class="{ active: isActiveAttributeValue(attributeValue) }"
          class="attribute"
          @click="setAttributeValue(product, service, attributeValue)"
        >
          <div
            class="image"
            :style="{
              backgroundImage: `url(${attributeValue.preferences[imageAttribute]})`,
            }"
          />

          <p
            class="sold-text"
            v-html="$t('Sold')"
          />
        </div>
      </Tooltip>
    </div>
    <!-- text field -->
    <div
      v-if="showPackagingTextInput"
      class="form-group"
    >
      <input
        v-model="product.attributes.packagingText"
        type="text"
        name="packageText"
        :placeholder="$t('Text on package')"
      >
    </div>
  </div>
</template>
<script>
import { computed } from '@vue/reactivity'
import { mapGetters } from 'vuex'
import Input from '../../../views/partials/input/Input.vue'
import useProductService from './useProductService'
import Tooltip from '../tooltip/Tooltip.vue'
import useProduct from '../../../views/product/useProduct'

export default {
  components: {
    Input,
    Tooltip,
  },
  props: {
    service: {
      type: Object,
    },
    product: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      language: 'cart/getLanguage',
    }),
    showPackagingTextInput() {
      return this.activeAttributeValue.id === this.attributeWithPackagingText
    },
    imageAttribute() {
      return `${this.language.domain}ImageUrl`
    },
  },
  methods: {
    isActiveAttributeValue(attributeValue) {
      return this.activeAttributeValue.id === attributeValue.id
    },
  },
  setup(props) {
    const {
      setAttributeValue,
      getActiveAttributeValue,
      attributeWithPackagingText,
    } = useProductService()

    const { soldProductWithAttribute, getAttributeTooltipText } = useProduct()

    const activeAttributeValue = computed(() => getActiveAttributeValue(props.product))

    return {
      getAttributeTooltipText,
      activeAttributeValue,
      setAttributeValue,
      attributeWithPackagingText,
      soldProductWithAttribute,
    }
  },
}
</script>
